import { render, staticRenderFns } from "./AwsAd.vue?vue&type=template&id=d266274c&scoped=true&"
import script from "./AwsAd.vue?vue&type=script&lang=js&"
export * from "./AwsAd.vue?vue&type=script&lang=js&"
import style0 from "./AwsAd.vue?vue&type=style&index=0&id=d266274c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d266274c",
  null
  
)

export default component.exports